import React from 'react'

function Refine(props) {
	return (
		<div>
			<h1>Refine</h1>
			<p>Work in progress</p>
		</div>
	)
}

export default Refine
